import React from 'react';
import { Box, Text } from '@wix/design-system';
import { clsx } from 'clsx';
import s from './MarqueeBanner.scss';
export const MarqueeBanner = _ref => {
  let {
    items,
    dataHook,
    gap = '4px',
    coloredItems = false,
    sizedIcon = false
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: s.container,
    "data-hook": dataHook
  }, /*#__PURE__*/React.createElement(Box, {
    className: s.track,
    verticalAlign: "middle"
  }, ['a', 'b', 'c', 'd'].map(copy => items.map(_ref2 => {
    let {
      id,
      Icon,
      text
    } = _ref2;
    return /*#__PURE__*/React.createElement(Box, {
      key: `${id}-${copy}`,
      className: clsx(s.item, coloredItems && s.colored),
      gap: gap,
      verticalAlign: "middle"
    }, /*#__PURE__*/React.createElement(Icon, {
      className: sizedIcon ? s.icon : undefined
    }), /*#__PURE__*/React.createElement(Text, {
      size: "tiny",
      secondary: true
    }, text));
  }))));
};
//# sourceMappingURL=MarqueeBanner.js.map